import { Injectable } from '@angular/core';
import { MenuItem } from '../models/sidebar';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  menuItems: MenuItem[] = [];

  constructor() {
    this.loadMenuItems();
  }

  private loadMenuItems() {
    this.menuItems = [];

    const flags: { [key: string]: boolean } = {
      agrinio: environment.agrinio,
      people: environment.people,
      structural: environment.structural,
      traffic: environment.traffic,
      mediaServer: environment.mediaServer
    };

    const activeFlags = Object.keys(flags).filter(flag => flags[flag]);

    if (activeFlags.length === 0) {
      this.menuItems.push({
        icon: 'dashboard',
        label: 'Home',
        route: 'home',
        submenu: [],
        showSubmenu: false
      });

      this.menuItems.push({
        icon: 'settings',
        label: 'Management',
        route: 'management',
        submenu: [
          {
            icon: 'device_hub',
            label: 'Devices',
            route: 'management/devices',
            submenu: [],
            showSubmenu: false
          }
        ],
        showSubmenu: false
      });

      this.menuItems.push({
        icon: 'business',
        label: 'Stations',
        route: 'stations',
        submenu: [
          {
            icon: 'people',
            label: 'People',
            route: 'stations/people',
            submenu: [],
            showSubmenu: false
          }
        ],
        showSubmenu: false
      });

      this.menuItems.push({
        icon: 'location_city',
        label: 'Infrastructure',
        route: 'infrastructure',
        submenu: [
          {
            icon: 'engineering',
            label: 'Structural Health',
            route: 'infrastructure/structural-health',
            submenu: [],
            showSubmenu: false
          },
          {
            icon: 'construction',
            label: 'Traffic Monitoring',
            route: 'infrastructure/traffic-monitoring',
            submenu: [],
            showSubmenu: false
          }
        ],
        showSubmenu: false
      });

    } else {
      if (!(activeFlags.length === 1 && activeFlags[0] === 'agrinio') &&
        !(activeFlags.length === 1 && activeFlags[0] === 'mediaServer')) {
        this.menuItems.push({
          icon: 'dashboard',
          label: 'Home',
          route: 'home',
          submenu: [],
          showSubmenu: false
        });
      }
      if (environment.people || environment.structural || environment.traffic) {
        const managementSubmenu: MenuItem[] = [
          {
            icon: 'device_hub',
            label: 'Devices',
            route: 'management/devices',
            submenu: [],
            showSubmenu: false
          }
        ];
        this.menuItems.push({
          icon: 'settings',
          label: 'Management',
          route: 'management',
          submenu: managementSubmenu,
          showSubmenu: false
        });
      }

      if (environment.people) {
        const stationsSubmenu: MenuItem[] = [
          {
            icon: 'people',
            label: 'People',
            route: 'stations/people',
            submenu: [],
            showSubmenu: false
          }
        ];
        this.menuItems.push({
          icon: 'business',
          label: 'Stations',
          route: 'stations',
          submenu: stationsSubmenu,
          showSubmenu: false
        });
      }

      if (environment.structural || environment.traffic) {
        const infrastructureSubmenu: MenuItem[] = [];
        if (environment.structural) {
          infrastructureSubmenu.push({
            icon: 'engineering',
            label: 'Structural Health',
            route: 'infrastructure/structural-health',
            submenu: [],
            showSubmenu: false
          });
        }
        if (environment.traffic) {
          infrastructureSubmenu.push({
            icon: 'construction',
            label: 'Traffic Monitoring',
            route: 'infrastructure/traffic-monitoring',
            submenu: [],
            showSubmenu: false
          });
        }
        this.menuItems.push({
          icon: 'location_city',
          label: 'Infrastructure',
          route: 'infrastructure',
          submenu: infrastructureSubmenu,
          showSubmenu: false
        });
      }

      if (environment.agrinio) {
        this.menuItems.push({
          icon: 'assignment',
          label: 'Access Control',
          route: 'access-control',
          submenu: [
            {
              icon: 'person_add',
              label: 'Users Whitelist',
              route: 'access-control/whitelist',
              submenu: [],
              showSubmenu: false
            },
            {
              icon: 'lock',
              label: 'Access Management',
              route: 'access-control/management',
              submenu: [],
              showSubmenu: false
            },
          ],
          showSubmenu: false
        });
      }

      if (environment.mediaServer) {
        this.menuItems.push({
          icon: 'videocam',
          label: 'Media Server',
          route: 'media-server',
          submenu: [],
          showSubmenu: false
        });
      }
    }
  }

  getMenuItems(): MenuItem[] {
    return this.menuItems;
  }
}